import ScriptSuccessModal from "./ScriptSuccessModal";
import IconDownloading from "./download.svg?react";
import videoDetailService from "@apis/videoDetailService";
import { useAppDispatch } from "@hooks/redux";
import report from "@report";
import { DownloadingItem, finishDownloadScript } from "@store/globalVideoSlice";
import { updateFeautreDownloadVideo } from "@store/memberCenterSlice";
import message from "@utils/message";
import { sleep } from "@utils/util";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Trans } from "react-i18next";

interface ScriptItemProps {
  downloadItem: DownloadingItem;
}

export default ({ downloadItem }: ScriptItemProps) => {
  const dispatch = useAppDispatch();
  const refWrapper = useRef<null | HTMLDivElement>(null);
  const refProgress = useRef<null | HTMLDivElement>(null);
  const [progress, setProgress] = useState(0);
  const refDownloadStatus = useRef("");
  const [script, setScript] = useState("");
  const [isFinish, setFinish] = useState(false);
  const [isSuccess, setSucccess] = useState(false);

  useEffect(() => {
    const startTime = new Date().getTime();
    const totalTime = 120;
    const timer = setInterval(() => {
      const currentTime = new Date().getTime();
      if (currentTime - startTime > totalTime * 1000) {
        return;
      }
      const percent = Math.min(0.99, ((new Date().getTime() - startTime) * 6) / 1000 / totalTime);
      const progress = Number((percent * 100).toFixed(0));
      const offset = percent * 125;
      setProgress(progress);
      if (refWrapper && refWrapper.current) {
        refWrapper.current.querySelector(".loading_circle")?.setAttribute("stroke-dashoffset", String(125 - offset));
      }
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const getTranscriptionStatus = async (): Promise<string> => {
    if (refDownloadStatus.current !== "CANCEL") {
      const data = await videoDetailService.getTranscriptionStatus({
        countryCode: downloadItem.region,
        videoId: downloadItem.videoId,
      });
      if (data === "IN_PROGRESS") {
        await sleep(3000);
        return await getTranscriptionStatus();
      }
      if (data === "FAILED") {
        throw new Error("FAILED");
      }
      if (data === "COMPLETED") {
        report.event("export_script_success", { kalo_value: downloadItem.videoId });
        return "COMPLETED";
      }
      return "";
    } else {
      return "CANCEL";
    }
  };

  const downloadTranscription = async () => {
    const response = await axios({
      url: "/video/downloadTranscription",
      method: "post",
      responseType: "blob",
      headers: {
        "content-type": "application/json",
      },
      data: {
        countryCode: downloadItem.region,
        id: downloadItem.videoId,
      },
    });

    const script = await response.data.text();
    setScript(script);
    setFinish(true);

    // let blob = new Blob([response.data], { type: "application/octet-stream" });
    // const url = window.URL.createObjectURL(blob);
    // const a = document.createElement("a");
    // a.download = `script_${downloadItem.videoId}.txt`;
    // a.href = url;
    // a.click();
  };

  useEffect(() => {
    (async () => {
      try {
        report.event("export_script", { kalo_value: downloadItem.videoId });
        await videoDetailService.applyTranscription({
          countryCode: downloadItem.region,
          videoId: downloadItem.videoId,
        });
        const status = await getTranscriptionStatus();
        if (status === "COMPLETED") {
          await sleep(2000);
          await downloadTranscription();
          setSucccess(true);
        }
        if (status === "CANCEL") {
          dispatch(finishDownloadScript(downloadItem.videoId));
        }
      } catch (error) {
        message.error(error);
        dispatch(finishDownloadScript(downloadItem.videoId));
      }
      setFinish(true);
      dispatch(updateFeautreDownloadVideo());
    })();
  }, []);

  return (
    <>
      {!isFinish && (
        <div className="item">
          <div className="downloading" ref={refWrapper}>
            <IconDownloading className="icon"></IconDownloading>
            <div>
              <Trans>Export script</Trans> <span ref={refProgress}>{progress}</span>%
            </div>
            <div
              className="cancel"
              onClick={() => {
                refDownloadStatus.current = "CANCEL";
              }}
            >
              <Trans>Cancel</Trans>
            </div>
          </div>
        </div>
      )}
      {isSuccess && (
        <ScriptSuccessModal
          script={script}
          visible={isSuccess}
          onCancel={() => {
            dispatch(finishDownloadScript(downloadItem.videoId));
          }}
        ></ScriptSuccessModal>
      )}
    </>
  );
};
